module.exports = __webpack_public_path__ + "img/10.0afb7cf2.png";